// Нүүр хуудсанд: бүртгүүлсэн Passion хөтөлбөрүүд — "Баталгаажуулалт хүлээж буй" ба "Баталгаажсан". Юу ч үгүй бол харагдахгүй.
// who: "me" (сурагч) эсвэл хүүхдийн id (эцэг эх). Дарвал /passion?p=<id> — постер нь нээгдэнэ.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { instance } from "utils/axios";
import { assetUrl, scheduleRows } from "./Poster";

export default function MyPrograms({ who = "me", title }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    instance({ method: "get", url: `/student/passion/${who}`, silent: true }).then((r) => setD(r.data)).catch(() => setD(null));
  }, [who]);
  const mine = (d?.programs || []).filter((p) => p.mine && p.mine.status !== "interest");
  if (!mine.length) return null;
  const pending = mine.filter((p) => p.mine.status !== "confirmed");
  const confirmed = mine.filter((p) => p.mine.status === "confirmed");
  const q = who === "me" ? "" : `s=${who}&`;

  const Row = ({ p }) => {
    const s = p.sessions.find((x) => x.id === p.mine.sessionId);
    const r = s ? [s.days, s.time].filter(Boolean).join(" · ") : scheduleRows(p).map((x) => [x.days, x.time].filter(Boolean).join(" · ")).join(" / ");
    return (
      <Link to={`/passion?${q}p=${p.id}`} className="flex items-center gap-3 !text-[#1c1c1c]">
        <span className="h-12 w-12 rounded-xl overflow-hidden bg-[#2a1245] shrink-0">{p.coverUrl && <img src={assetUrl(p.coverUrl)} alt="" className="h-full w-full object-cover" />}</span>
        <span className="flex-1 min-w-0">
          <span className="block font-bold text-sm truncate">{p.name}</span>
          <span className="block text-xs text-[#6e5e8a] truncate">{r}</span>
        </span>
        <FiChevronRight className="text-primary shrink-0" />
      </Link>
    );
  };

  return (
    <section className="tj-card p-4 flex flex-col gap-3">
      <h2 className="m-0 text-base font-bold">{title || "Passion Program"}</h2>
      {pending.length > 0 && (
        <div className="flex flex-col gap-2.5">
          <span className="self-start text-[11px] font-bold rounded-full px-2 py-0.5 bg-[#fffbeb] text-[#92400e]">Бүртгүүлсэн · баталгаажуулалт хүлээж буй</span>
          {pending.map((p) => <Row key={p.id} p={p} />)}
          <span className="text-xs text-[#6e5e8a] leading-relaxed">Сурагчийн тоо бүрдсэн тохиолдолд барьцаа төлбөр байршуулах мэдэгдэл очно.</span>
        </div>
      )}
      {confirmed.length > 0 && (
        <div className="flex flex-col gap-2.5">
          <span className="self-start text-[11px] font-bold rounded-full px-2 py-0.5 bg-[#dcfce7] text-[#166534]">Баталгаажсан</span>
          {confirmed.map((p) => <Row key={p.id} p={p} />)}
        </div>
      )}
    </section>
  );
}
